import React, { useState } from 'react';
import styled from '@emotion/styled';

import SlickBar from 'components/SlickBar';
import VideoThumbnail from '../elements/VideoThumbnail';
import VideoModal from 'components/VideoModal';

import vw from 'styles/utils';

import videosData from 'data/video';

function VideoBar() {
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);

  const handleClickCloseButton = () => {
    // setSelectedVideoIndex(0);
    setIsShowModal(false);
  }

  const handleShowModal = (index) => {
    setSelectedVideoIndex(index);
    setIsShowModal(true);
  }

  const handleClickPrevButton = () => {
    if (selectedVideoIndex===0) {
      setSelectedVideoIndex(videosData.length-1);
    } else {
      setSelectedVideoIndex(selectedVideoIndex-1);
    }
  }

  const handleClickNextButton = () => {
    if (selectedVideoIndex===videosData.length-1) {
      setSelectedVideoIndex(0);
    } else {
      setSelectedVideoIndex(selectedVideoIndex+1);
    }
  }

  return (
    <Root>
      <SlickBar
        icon={require('assets/images/icons/net-zero.png')}
        title="淨零學院 FREE"
      >
        {
          videosData.map((video, index) => (
            <VideoThumbnail
              src={video.thumbnail}
              title={video.title}
              onClick={() => handleShowModal(index)}
              key={`video ${index}`}
            />
          ))
        }
      </SlickBar>
      <VideoModal
        show={isShowModal}
        selectedVideoIndex={selectedVideoIndex}
        onClickPrevButton={handleClickPrevButton}
        onClickNextButton={handleClickNextButton}
        onClickCloseButton={handleClickCloseButton}
      />
    </Root>
  )
}

const Root = styled.section`
  ${vw('margin-bottom', 30, 60)}
`;

export default VideoBar
